import moment from "moment";
import { toast } from "react-toastify";
const HelperService = {
  getFormatedDateForDetail(dt: any, format?: any) {
    if (dt) {
      var stillUtc = moment.utc(dt).toDate();
      if (format) {
        return moment(stillUtc).local().format(format);
      } else {
        return moment(stillUtc).local().format(
          (localStorage.getItem("date_format") ?? "DD-MM-YYYY") + " hh:mm A"
        );
      }
    }
  },

  toQueryString(params: any) {
    const query = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, String(value));
      }
    });

    return query.toString();
  },
  checkFormEmptyFields(obj: any, excludedKeys: string[] = []): boolean {
    let emptyKeyFlag = false;
    const excludedKeysSet = new Set(excludedKeys);

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      // Skip excluded keys
      if (excludedKeysSet.has(key)) return;

      // ✅ Special case: validate email
      if (key === "email") {
        if (!this.isValidEmail(value)) {
          console.log("Invalid Email:", value);
          emptyKeyFlag = true;
        }
      }

      // ✅ Handle valid boolean false (e.g., is_active: false)
      if (typeof value === "boolean") {
        return; // false is valid
      }

      // ✅ Handle File or Blob — treat as non-empty
      if (value instanceof File || value instanceof Blob) {
        return;
      }

      // ✅ Handle Date
      if (value instanceof Date) {
        // Invalid date or empty
        if (isNaN(value.getTime())) {
          console.log("Invalid or Empty Date:", key);
          emptyKeyFlag = true;
        }
        return; // valid date → skip
      }

      // ✅ Check for emptiness for strings, numbers, nulls, or objects
      const isEmptyValue =
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value === "object" && Object.keys(value).length === 0);

      if (isEmptyValue) {
        console.log("Empty Key:", key);
        emptyKeyFlag = true;
      }
    });

    return emptyKeyFlag;
  },
  isValidEmail(email: string) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  },
  formatTimeTo12Hour(time24: string): string {
    if (!time24) return "";

    const [hourStr, minuteStr] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`;
  },
  showSingleError(msg: string) {
    toast.error(msg, {
      toastId: "single-error-toast", // Ensures only one error toast exists
      autoClose: 4000,
      delay: 100,
    });
    toast.dismiss(); // Removes all previous toasts
  },
  validateEmail(email: any) {
    const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  },
  validatePassword(pass: any) {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&])[A-Za-z\d@$!%*?#&]{8,}$/;
    return regex.test(pass);
  },
  removeUnderScore(str: any) {
    if ((str !== "" || str !== undefined) && str.includes("_")) {
      return this.titleCase(str.replace(/_/g, " "));
    } else {
      return this.titleCase(str);
    }
  },
  removeDialCodeFromMobile(mobileNumber: any, dialCode: any) {
    if (
      typeof mobileNumber === "string" &&
      typeof dialCode === "string" &&
      dialCode.length > 0
    ) {
      if (mobileNumber.startsWith(dialCode)) {
        return mobileNumber.slice(dialCode.length);
      }
    }
    return mobileNumber;
  },
  titleCase(str: any) {
    if (str !== "") {
      return str
        .toLowerCase()
        .split(" ")
        .map((word: any) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    } else {
      return str;
    }
  },
};



export default HelperService;
